import { gql } from '@apollo/client';

export const UPDATE_BOOKING_STATUS = gql`
  mutation UpdateBookingStatus($bookingId: ID!, $chequeId: String, $status: BookingStatus!) {
    updateBookingStatus(bookingId: $bookingId, chequeId: $chequeId, status: $status) {
      success
      message
      error
      booking {
        id
        status
        partySize
        comment
        guestName
        discountPercent
      }
    }
  }
`;

export const MOVE_BOOKING_TO_TABLE = gql`
  mutation MoveBookingToTable($bookingId: ID!, $tableIds: [ID!]!) {
    moveBookingToTable(bookingId: $bookingId, tableIds: $tableIds) {
      success
      error
    }
  }
`;
